module.exports = __webpack_public_path__ + "static/img1-cdce512487bc48d80bd89de77f8af0c3.jpg";